export default __webpack_public_path__ + "static/media/noConcern.56b5008d.jpg";